
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/warranty",
      function () {
        return require("private-next-pages/article/warranty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/warranty"])
      });
    }
  